/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */

import EnvironmentInfo from '../environment-info';

class AccessPrivilege {
  private readonly caseTypeAccessMap = new Map<string, boolean>();
  static instance: AccessPrivilege;
  constructor() {
    this.caseTypeAccessMap = EnvironmentInfo.getCaseTypeList().reduce((map, caseType) => {
      map.set(caseType.pyWorkTypeImplementationClassName, caseType.hasCreateAccess ?? true);
      // for infinity caseType.pyHasCreateAccess needs to be tested for access role . populated in  pxPopulateEnvironmentInfo activity
      return map;
    }, new Map<string, boolean>());
  }

  /* private toBoolean(value: string | boolean | undefined): boolean {
    return value === 'true' || value === true;
  } */

  /**
   * This API tells if the provided caseType has create access or not
   * @returns {boolean} return false if the user doesn't have access else returns true
   * @private
   */
  hasCreateAccess(caseType: string): boolean {
    return this.caseTypeAccessMap.get(caseType) as boolean;
  }

  /**
   * This API tells provides the single Instance of AccessPrivilege
   * @returns {object} returns the AccessPrivilege instance
   * @private
   */
  static getInstance() {
    if (!this.instance) {
      this.instance = new this();
    }
    return this.instance;
  }
}

export default AccessPrivilege;
